import ErrorMessage from 'components/elements/items/ErrorMessage'
import WarningMessage from 'components/elements/items/WarningMessage'
import React from 'react'
import styled from 'styled-components'

/**
 * 画面下部のエラー文、注意文表示エリア
 */
const NoteArea: React.FC<NoteAreaProps> = (props) => {
  return (
    <StyledNoteArea>
      {props.error && <ErrorMessage message={props.error} />}
      {props.warning && <WarningMessage message={props.warning} />}
    </StyledNoteArea>
  )
}

export type NoteAreaProps = {
  warning?: string
  error?: string
}

const StyledNoteArea = styled.div`
  margin: 0 auto;
`

export default NoteArea
